class Product
  constructor: (@container) ->
    data = @container.data()
    @id = data.id
    @singlePrice = data.isSinglePrice
    @name = data.name
    @priceView = @container.find("#price-view")
    @priceTemplate = _.template($("#price-template").html())

    @packages = @container.find("#packages")
    @singlePrice = $('#single-price')
    @cartForm = $("#cart-form")
    @packages.on "change", () =>
      option = @packages.find("option:selected")
      @cartForm.removeClass("pw-0").addClass("pw-" + option.data("type"))
      @priceView.html(@priceTemplate({
        price: @readOptionPrice(option, "price"),
        promo: @readOptionPrice(option, "promo")
      }))


  readOptionPrice: (option, priceKey)->
    weight = option.data("weight")
    price = option.data(priceKey)
    if price
      if weight
        return (parseFloat(price) * weight).toFixed(2)
      return parseFloat(price).toFixed(2)

  packageData: ->
    if @singlePrice.length == 1
      return @singlePrice.data()
    @packages.find(":selected").data();

  package: ->
    @packageData().id

  isSinglePrice: () -> @singlePrice

  getPrice: () ->
    if @isSinglePrice()
      tag = @container.find('.product-price')
    else
      checkbox = @container.find('.prettyCheckbox.checked')
      tag = checkbox.find('.product-price')

    return parseFloat tag.last().text()



  getName: ->
    return @name

# returns product attribute id instead of literal size
  size: ->
#    if !@isSinglePrice()
    pa = @container.find('.selectSize :checked').val()
    parseInt pa
#    else
#      null

  attr: ->
    data = []
    @container.find('.attr option:selected:not(:disabled)').each (i, e) ->
      data.push(e.dataset.pa)
    data

  getSize: ->
    if !@isSinglePrice()
      @container.find ".prettyCheckbox.checked"
        .data "size"
    else
      null


class Cart

  # class sekcji koszyka - musi znajdować się w @container - zawiera wszystkie istotne informacje dla koszyka
  CART_SECTION = '.cart-section'

  # selector przycisku dodaj do koszyka
  ADD_TO_CART = '.add-to-cart'

  # input z ilością jaka ma być dodana do koszyka
  QUANTITY_INPUT = '.qty'

  constructor: (@container) ->
    @globalSources = new Sources "#global-sources"

    # obiekt powiadomień
    @notif = new CartNotification(@globalSources.get("ok"), @globalSources.get("added"), @globalSources.get('noSize'), @globalSources.get("error"))

    @product = new Product @container

    # sekcja koszyka na widoku produktu
    @section = @container.find CART_SECTION
    @section.find(ADD_TO_CART).click @clickAddToCart

    # url na jaki wysyłany jest request z produktem do dodania do koszyka
    @addUrl = @section.data "add-url"

    @quantityInput = @section.find QUANTITY_INPUT
    @productTpl = _.template($('#mini-cp-tpl').html())
    @ext = $('#cart-ext-list')
    @extTitle = $('#cart-extension-title')
    @extSubtotal = $('#cext-sub')
    @extCheckoutBtn = $('#cext-checkout')
    @cartTotalValue = $('.cart-total-value')
    @cartCounter = $('.cart-counter')

  clickAddToCart: (e) =>
    e.preventDefault()
    data =
      productId: @product.id
      quantity: parseInt(@quantityInput.val())
      productSizeId: @product.size()

    $.ajax(
      type: "post"
      url: @addUrl
      contentType: 'application/json'
      data: JSON.stringify(data)
    ).done(@onAddResponse)
      .fail(@addResponseFail)


  onAddResponse: (r, textStatus, jqXhr) =>
    if jqXhr.status == 200
      @notif.added()

      cpRow = @ext.find('.cp-row-' + r.id)
      console.log(cpRow)
      cpSubtotal = r.cartProductSubTotals[r.id]
      if cpRow.length == 0
        data =
          id: r.id
          productImg: r.productImg
          productUrl: r.productUrl
          currency: r.currency
          quantity: r.quantity
          subtotal: cpSubtotal
          name: r.productName
        console.log(data)
        compiledTpl = @productTpl(data)
        console.log(compiledTpl);
        cpRow = $(compiledTpl).appendTo(@ext)
      else
        cpQty = cpRow.find('.cp-quantity-' + r.id)
        console.log(cpQty)
        cpQty.text(r.quantity)
        cpSub = cpRow.find('.cp-subtotal-' + r.id)
        console.log(cpSub)
        cpSub.text(cpSubtotal)

      @extTitle.text(r.cartExtensionTitle)
      @cartTotalValue.text(r.totalCartValue)
      @extSubtotal.show()
      @extCheckoutBtn.show()
      @cartCounter.text(r.totalProducts)
    else
      @notif.error r.message

  addResponseFail: (jqXhr) =>
    if jqXhr.status == 400
      @notif.error jqXhr.responseJSON.errors
